/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

interface ConfigFlowMutationProps {
    flow_id: string;
    options: string;
    organisation_id: string;
}

export default class ConfigFlowMutation extends Relay.Mutation<ConfigFlowMutationProps> {
    static propTypes = {
        flow_id: PropTypes.string.isRequired,
        options: PropTypes.string.isRequired,
        organisation_id: PropTypes.string.isRequired,
    };

    getMutation() {
        return Relay.QL`mutation {configFlow}`;
    }

    getVariables() {
        return {
            flow_id: this.props.flow_id,
            organisation_id: this.props.organisation_id,
            options: this.props.options,
        };
    }

    getFatQuery() {
        return Relay.QL`
          fragment on ConfigFlowPayload {

              clientMutationId,
              updatedNode {
                  id,
                  realId,
                  options,
                  configOptions,
                  hasInvalidChannel,
                  invalid,
                  manualButtons(first: 100) {
                    edges {
                        node {
                            id,
                            realId,
                            type,
                            flowStepDef_id,
                            flowStepDef {
                                id,
                                realId,
                                name
                            },
                        }
                    }
                },
                manualForms(first: 100) {
                    edges {
                        node {
                            id,
                            realId,
                            type,
                            flowStepDef_id,
                            flowStepDef {
                                id,
                                realId,
                                key,
                                name
                            },
                        }
                    }
                },
              }
          }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }
}
